import type { BlockedReason } from "resources/scheduled-workflows/types"

export const BLOCKED_COPY: Record<Exclude<BlockedReason, "over_budget">, string> = {
  credential_invalid: "The owner's access couldn't be confirmed.",
  pat_disabled: "Personal access tokens are off for this account. An admin has to turn them back on.",
  repeated_failures: "Paused after several failed runs.",
  platform_paused: "Paused by a platform problem. Contact support.",
}

export const FEATURE_OFF_COPY = "Scheduled workflows aren't turned on for this account."

export const AI_NOT_ACTIVATED_COPY = "AI isn't activated for this account. Ask an admin to turn it on."

export const PAUSED_COPY = "Paused. Turn on to resume."

export const MANUAL_ONLY_ACTIVE_COPY = "Only when you run it"

export const MANUAL_ONLY_PAUSED_COPY = "Runs when you click Run now"
